module.exports = __webpack_public_path__ + "media/icons/expired_download-4d34ec57.svg";